import { makeStyles, createStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

interface StyleProps {
  isMobile: boolean;
  width: number | string;
  chartSize: number | string;
}

const useStyles = makeStyles<Theme, StyleProps>(() =>
  createStyles({
    chartContainerRoot: (props) => ({
      display: "flex",
      flexDirection: props.isMobile ? "column" : "row",
      justifyContent: "space-between",
      alignItems: props.isMobile ? "center" : "unset",
    }),
    chartContainer: (props) => ({
      display: "flex",
      position: "relative",
      width: props.width,
      height: props.chartSize,
      padding: 5,
      textAlign: "center",
      marginRight: props.isMobile ? 0 : 28,
      marginLeft: props.isMobile ? 0 : 12,
    }),
    legendMainContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      height: "auto",
      width: "100%",
      paddingTop: 5,
    },
  })
);

export default useStyles;
